var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white",
    stroke: "#54C000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM17.94 8.83L10.44 17.33C10.3263 17.4573 10.1878 17.5602 10.0331 17.6324C9.87842 17.7046 9.71065 17.7446 9.54 17.75C9.37598 17.7506 9.21351 17.7182 9.06231 17.6546C8.91111 17.5911 8.77428 17.4977 8.66 17.38L6.16 14.88C6.04444 14.7644 5.95277 14.6272 5.89023 14.4763C5.82769 14.3253 5.7955 14.1634 5.7955 14C5.7955 13.8366 5.82769 13.6747 5.89023 13.5237C5.95277 13.3728 6.04444 13.2356 6.16 13.12C6.27557 13.0044 6.41276 12.9128 6.56375 12.8502C6.71474 12.7877 6.87657 12.7555 7.04 12.7555C7.20344 12.7555 7.36527 12.7877 7.51626 12.8502C7.66725 12.9128 7.80444 13.0044 7.92 13.12L9.48 14.68L16.1 7.17C16.3201 6.9207 16.6303 6.76905 16.9622 6.74842C17.2942 6.72779 17.6207 6.83987 17.87 7.06C18.1193 7.28013 18.271 7.59028 18.2916 7.92222C18.3122 8.25416 18.2001 8.5807 17.98 8.83H17.94Z",
    fill: "#54C000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.564b6d2ef3ba2d93a6ac0c141acd5d63.svg";
export { ForwardRef as ReactComponent };